/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, Component } from "react";
import { Row, Col, } from 'reactstrap';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
// Replace react-excel-renderer with xlsx
import * as XLSX from 'xlsx';
import SmallLoader from '../../../../shared/components/SmallLoader';
import history from '../../../App/History';
import ProductResizableTable from '../../UploadProductExcel/ProductResizableTable';
import { tableHeaderDataForUploadPOS as tableHeaderData } from "../../helper";

export default class POSExcelImport extends Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = false;
    this.isError = false;
    this.isLoading = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';
    this.state = {
      cols: [],
      rows: [],
      regexp: /^\$?[0-9.,]+$/,
      errorMessage: null,
      columns: [
        {
          title: "SKU",
          dataIndex: "key",
          editable: true,
          width: 180
        },
        {
          title: "Description",
          dataIndex: "description",
          editable: true,
          width: 220
        },
        {
          title: "Sold qty",
          dataIndex: "quantitySold",
          editable: true,
          width: 200
        },
        {
          title: "Amount",
          dataIndex: "amount",
          editable: true,
          width: 200
        },
        {
          title: "Month (1~12)",
          dataIndex: "month",
          editable: true,
          width: 200
        },
        {
          title: "Year",
          dataIndex: "year",
          editable: true,
          width: 200
        },
        {
          title: "Week",
          dataIndex: "week",
          editable: true,
          width: 200
        },
        {
          title: "Company name",
          dataIndex: "companyName",
          editable: true,
          width: 200
        }
      ]
    };
  }

  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  onImportExcel = (event) => {
    const { files } = event.target;
    console.log(files[0].type)
    if (files.length === 1) {
      if (!(files[0].type === "application/vnd.ms-excel" ||
        files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format. Only Excel files are uploaded!',
            duration: 5,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
        this.setState({
          errorMessage: "Unknown file format. Only Excel files are uploaded!"
        });
      }
      else {
        // Use SheetJS to read the Excel file
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Get the first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          const newRows = [];
          // Skip the header row (index 0) and process data rows
          jsonData.slice(1).forEach((row, index) => {
            if (row && row.length > 0) {
              if (row[0] !== undefined || row[1] !== undefined || row[7] !== undefined) {
                newRows.push({
                  key: String(row[0] || ''),
                  description: String(row[1] || ''),
                  quantitySold: row[2] === undefined ? '0' : String(row[2]),
                  amount: !(this.state.regexp.test(row[3])) ? '0' : String(row[3] || '').replace(/\$|,/g, ''),
                  month: String(row[4] || ''),
                  year: String(row[5] || ''),
                  week: String(row[6] || ''),
                  companyName: String(row[7] || ''),
                });
              }
            }
          });

          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: { top: 120, fontWeight: "bold" },
              });
            });
          } else {
            this.isError = false;
            this.isEmptyCell = false;
          }

          console.log(newRows)
          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: { top: 120, fontWeight: "bold" },
                maxCount: 50
              });
            });
          } else {
            this.setState({
              cols: [], // SheetJS doesn't provide cols in the same format
              rows: newRows,
              errorMessage: null
            });
          }
        };
        reader.readAsArrayBuffer(files[0]);
      }
    }
    else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  };

  handleSubmit = async () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'Please wait....',
        duration: 10,
        style: { top: 200, fontWeight: "bold" },
        maxCount: 40
      });
    });
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token
      },
      body: JSON.stringify(this.state.rows)
    };
    this.isLoading = true;
    const response = await fetch('https://rss.getrael.com/api/wholesale/pointofsales/update', requestOptions);
    const data = await response.json();
    if (data.code === '200') {
      this.isLoading = false;
      this.setState({ rows: [] })
      this.input.current.value = ""
      history.push('/pos/details')
    }
    else if (data.code === '403') {
      this.isLoading = false;
      history.push('/login')
    }
    else {
      this.isLoading = false;
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Point of sales not upload, Please try again!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
      console.log("Point of sales not upload, Please try again!")
    }
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };

  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };

  render() {
    console.log(this.isLoading)
    const components = {
      body: {
        //  row: EditableFormRow,
        //  cell: EditableCell
      }
    };
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    return (
      <>
        <Col md={12}>
          <Row>
            <Col md="6">
              <input className="file-uploader" type="file" accept=".xlsx, .xls, .csv" onChange={this.onImportExcel}
                ref={this.input} />
              &nbsp;<Button className="btn btn-sm btn-danger"
                style={{ marginTop: 16 }}
                onClick={this.clearData}
              >
                &nbsp;Clear
              </Button>
            </Col>
            <Col md="6" align="right">
              {this.state.rows.length > 0 && (
                <>
                  <Button
                    onClick={this.handleSubmit}
                    size="large"
                    type="primary"
                    className="btn btn-primary btn-sm"
                    disabled={this.isEmptyCell}
                    style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                  >
                    Submit Data
                  </Button>
                </>
              )}
              <Button
                onClick={() => history.push('/pos/details')}
                size="large"
                type="danger"
                className="btn btn-primary btn-sm"
                style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
              >
                Back To Product
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12}>
              <div className="top-location"
                style={{ minHeight: '400' }}>
                <div >
                  {this.isLoading ? <div style={{ minHeight: '200px' }}
                    className="row align-items-center justify-content-center">
                    <SmallLoader loading={this.isLoading} />
                  </div>
                    : <ProductResizableTable customClass="pt-0" reactTableData={{ tableHeaderData }}
                      data={this.state.rows} />}
                </div>
              </div>

            </Col>
          </Row>
        </Col>
      </>
    );
  }
}